import { render, staticRenderFns } from "./batchInsure.vue?vue&type=template&id=5ce18d20&scoped=true"
import script from "./batchInsure.vue?vue&type=script&lang=js"
export * from "./batchInsure.vue?vue&type=script&lang=js"
import style0 from "./batchInsure.vue?vue&type=style&index=0&id=5ce18d20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce18d20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce18d20')) {
      api.createRecord('5ce18d20', component.options)
    } else {
      api.reload('5ce18d20', component.options)
    }
    module.hot.accept("./batchInsure.vue?vue&type=template&id=5ce18d20&scoped=true", function () {
      api.rerender('5ce18d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/customInsureManage/batchInsure.vue"
export default component.exports